import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	timelineLabel: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.view-bar.view-switcher.timeline-label',
		defaultMessage: 'Timeline',
		description: 'Label for "Timeline" menu item in view switcher',
	},
	teamsLabel: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.view-bar.view-switcher.teams-label',
		defaultMessage: 'Teams',
		description: 'Label for "Teams" menu item in view switcher',
	},
	releasesLabel: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.view-bar.view-switcher.releases-label',
		defaultMessage: 'Releases',
		description: 'Label for "Releases" menu item in view switcher',
	},
	dependenciesLabel: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.view-bar.view-switcher.dependencies-label',
		defaultMessage: 'Dependencies report',
		description: 'Label for "Dependencies report" menu item in view switcher',
	},
	switchViewsDropdownLabel: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.view-bar.view-switcher.switch-views-dropdown-label',
		defaultMessage: 'Switch views',
		description: 'Label for "dropdown" in view switcher',
	},
});
